// extracted by mini-css-extract-plugin
module.exports = {"SectionPlan":"area-of-expertise_SectionPlan__1ZE2v","SectionName":"area-of-expertise_SectionName__3du15","SectionContent":"area-of-expertise_SectionContent__2n3nh"};